import xz from "../common";
const m_addCompany = {
  state: {
    currentModule: 'addComapny',
    //企业类型
    // companyProperty: [{
    //   value: '外商独资/外企办事处',
    //   label: '外商独资/外企办事处'
    // }, {
    //   value: '中外合资/合作',
    //   label: '中外合资/合作'
    // }, {
    //   value: '私营/民办企业',
    //   label: '私营/民办企业'
    // }, {
    //   value: '国有企业',
    //   label: '国有企业'
    // }, {
    //   value: '上市公司',
    //   label: '上市公司'
    // }, {
    //   value: '贸易公司',
    //   label: '贸易公司'
    // }, {
    //   value: '非盈利机构',
    //   label: '非盈利机构'
    // }, {
    //   value: '政府/公共事业',
    //   label: '政府/公共事业'
    // }, {
    //   value: '农/林/牧/渔',
    //   label: '农/林/牧/渔'
    // }, {
    //   value: '多元化业务集团公司',
    //   label: '多元化业务集团公司'
    // }, {
    //   value: '学校',
    //   label: '学校'
    // }, {
    //   value: '其他',
    //   label: '其他'
    // }],
    companyProperty: [{
      value: '农、林、牧、渔业',
      label: '农、林、牧、渔业'
    },{
      value: '采矿业',
      label: '采矿业'
    },{
      value: '制造业',
      label: '制造业'
    },{
      value: '电力、热力、燃气及水生产和供应业',
      label: '电力、热力、燃气及水生产和供应业'
    },{
      value: '建筑业',
      label: '建筑业'
    },{
      value: '批发和零售业',
      label: '批发和零售业'
    },{
      value: '交通运输、仓储和邮政业',
      label: '交通运输、仓储和邮政业'
    },{
      value: '住宿和餐饮业',
      label: '住宿和餐饮业'
    },{
      value: '信息传输、软件和信息技术服务业',
      label: '信息传输、软件和信息技术服务业'
    },{
      value: '金融业',
      label: '金融业'
    },{
      value: '房地产业',
      label: '房地产业'
    },{
      value: '租赁和商务服务业',
      label: '租赁和商务服务业'
    },{
      value: '科学研究和技术服务业',
      label: '科学研究和技术服务业'
    },{
      value: '水利、环境和公共设施管理业',
      label: '水利、环境和公共设施管理业'
    },{
      value: '居民服务、修理和其他服务业',
      label: '居民服务、修理和其他服务业'
    }, {
      value: '教育',
      label: '教育'
    }, {
      value: '卫生和社会工作',
      label: '卫生和社会工作'
    }, {
      value: '文化、体育和娱乐业',
      label: '文化、体育和娱乐业'
    }, {
      value: '公共管理、社会保障和社会组织',
      label: '公共管理、社会保障和社会组织'
    }, {
      value: '国际组织',
      label: '国际组织'
    }],
    //公司规模
    scale: [{
      value: '1-49人',
      label: '1-49人'
    }, {
      value: '50-149人',
      label: '50-149人'
    }, {
      value: '150-499人',
      label: '150-499人'
    }, {
      value: '500-999人',
      label: '500-999人'
    }, {
      value: '1000-2000人',
      label: '1000-2000人'
    }, {
      value: '2000-5000人',
      label: '2000-5000人'
    }, {
      value: '5000-10000人',
      label: '5000-10000人'
    }, {
      value: '10000人以上',
      label: '10000人以上'
    }],
    companyMatch: [],
    companyList: [],
    //判断是否有账号
    isHas: null,
    //账号信息
    accountInfo: "",
    //生成账号遮罩层
    produceSuccess: true,
    //修改获取到的企业信息
    companyInfor: null
  },
  mutations: {
    //企业名称判重
    searchMatch(state, field) {
      xz.iterateName(field).then((res) => {
        res ? state.companyMatch = res : console.log("企业名称判重出错");
      });
    },
    //检查企业是否已有账号
    // checkHasCount(state, item) {
    //   state.isHas = null; //初始化
    //   $.ajax({
    //     type: "post",
    //     url: APIB,
    //     data: {
    //       userid: Cookies.get('userid-b'),
    //       entid: item.entId,
    //       action: 'edit',
    //       pagename: 'bgetentacct',
    //     },
    //     dataType: "json",
    //     success: function (response) {
    //       var jsonRes = JSON.parse(response);
    //       if (jsonRes.status == 'ok') {
    //         //如果不存在
    //         if (!jsonRes.msg) {
    //           state.isHas = false;
    //           state.accountInfo = "";
    //         }
    //         //如果存在
    //         if (jsonRes.msg[0]) {
    //           state.isHas = true;
    //           state.accountInfo = jsonRes.msg[0];
    //         }
    //       }
    //     }
    //   });
    // },
    //生成账号
    produceAccount(state, accountInfo) {
      state.produceSuccess = false;
      xz.createCompanyAccount(accountInfo).then((res) => {
        state.produceSuccess = true;
        if(res){
          console.log("生成账号成功");
        }else{
          console.log("生成账号出错");
        }
      });
    },
    //获取修改企业的信息
    editCompanyInformation(state, companyId){
      xz.getCompanyInformation(companyId).then((res) => {
        res ? state.companyInfor = res : console.log("修改企业信息出错");
      });
    }
  },
};

export default m_addCompany;